<template>
  <div class="modal-tab">
    <h2 v-if="$slots.titre">
      <slot name="titre" />
    </h2>
    <div
      v-if="$slots.details"
      class="details"
    >
      <slot name="details" />
    </div>
    <div
      v-if="$slots.content"
      class="tab-content"
    >
      <slot name="content" />
    </div>
    <div
      v-if="$slots.buttons"
      class="buttons"
    >
      <slot name="buttons" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalTab",
};
</script>
